// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--rovo-expansion/search-page-results-quick-find';

import { MessageFrontend as createMessageFrontendRovoSearchPageQuickFind3PConnectorPreAuthNudge } from '@post-office/browser--rovo-expansion/rovo-search-page-quick-find-3p-connector-pre-auth-nudge/placements/in-app-v2/search-page-results-quick-find';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementFrontendProps } from '@post-office/browser--rovo-expansion/search-page-results-quick-find';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendRovoSearchPageQuickFind3PConnectorPreAuthNudge({
		messageTemplateId: 'rovo-search-page-quick-find-3p-connector-pre-auth-nudge',
	}),
];

export const RawPlacement: PlacementRendererStage<PlacementFrontendProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementFrontendProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementFrontendProps> = RawPlacement;
